module.exports = __webpack_public_path__ + "img/logo.83864207.png";